const PREFIX = 'RoomsAcceptance';

export const sliceKeys = {
  companies: 'companies',
  cities: 'cities',
  houses: 'houses',
  rooms: 'rooms',
  relatedRooms: 'relatedRooms',
  desks: 'desks',
  createPage: 'createPage',
  newConfigPage: 'newConfigPage',
  changeDesksSettingsPage: 'changeDesksSettingsPage',
  roomListView: 'roomListView',
  attachmentsFilter: 'attachmentsFilter',
};

export const acceptanceCreationSteps = {
  addressesSetup: 'addressesSetup',
  acceptanceSetup: 'acceptanceSetup',
};

export const housesFilterNames = {
  regions: 'regions',
};

export const roomsFilterNames = {
  stages: 'stages',
  steps: 'steps',
  types: 'types',
};

export const actionTypes = {
  // companies
  currentCompanyChanged: createCompaniesActionType('currentCompanyChanged'),
  companySearchChanged: createCompaniesActionType('companySearchChanged'),

  // cities
  currentCityChanged: createCitiesActionType('currentCityChanged'),

  // houses
  houseSearchChanged: createHousesActionType('houseSearchChanged'),
  houseSelectedSearchChanged: createHousesActionType(
    'houseSelectedSearchChanged'
  ),
  houseFilterChanged: createHousesActionType('houseFilterChanged'),
  houseSelected: createHousesActionType('houseSelected'),
  houseDeselected: createHousesActionType('houseDeselected'),
  houseAndRelationsDeleted: createHousesActionType('houseAndRelationsDeleted'),
  allHousesSelected: createHousesActionType('allHousesSelected'),
  allHousesDeselected: createHousesActionType('allHousesDeselected'),
  relationAdded: createHousesActionType('relationAdded'),
  relationDeleted: createHousesActionType('relationDeleted'),
  roomFromRelationDeleted: createHousesActionType('roomFromRelationDeleted'),
  roomsCountSet: createHousesActionType('roomsCountSet'),
  roomIncluded: createHousesActionType('roomIncluded'),
  roomExcluded: createHousesActionType('roomExcluded'),
  roomListIncluded: createHousesActionType('roomListInclude'),
  roomListExcluded: createHousesActionType('roomListExclude'),

  //rooms
  roomSearchChanged: createRoomsActionType('roomSearchChanged'),
  roomFilterChanged: createRoomsActionType('roomFilterChanged'),
  roomStateReset: createRoomsActionType('roomStateReset'),

  //related rooms
  relatedRoomsSearchChanged: createRelatedRoomsActionType(
    'relatedRoomsSearchChanged'
  ),

  // desks
  activeDeskIndexChanged: createDesksActionType('activeDeskIndexChanged'),

  //common

  // create page
  createStepChanged: createCreatePageActionType('stepChanged'),
  createReset: createCreatePageActionType('createReset'),

  // create new config page
  newConfigPageReset: createNewConfigPageActionType('newConfigPageReset'),

  // change desks settings page
  changeDesksSettingsPageReset: createChangeDesksSettingsPageActionType(
    'changeDesksSettingsPageReset'
  ),

  // room listv view
  rowExpansionToggled: createRoomListViewActionType('rowExpansionToggled'),

  // attachments filter
  attachmentsFilterSelectedRecordChanged: createAttachmentsFilterActionType(
    'selectedRecordChanged'
  ),
  attachmentsFilterSelectedDocTypeChanged: createAttachmentsFilterActionType(
    'selectedDocTypeChanged'
  ),
  attachmentsFilterSearchChanged: createAttachmentsFilterActionType(
    'searchChanged'
  ),
  attachmentsFilterReset: createAttachmentsFilterActionType('reset'),
};

function createActionType(slice, evtName) {
  return `${PREFIX}/${slice}/${evtName}`;
}

function createCompaniesActionType(evtName) {
  return createActionType(sliceKeys.companies, evtName);
}

function createCitiesActionType(evtName) {
  return createActionType(sliceKeys.cities, evtName);
}

function createHousesActionType(evtName) {
  return createActionType(sliceKeys.houses, evtName);
}

function createRoomsActionType(evtName) {
  return createActionType(sliceKeys.rooms, evtName);
}

function createRelatedRoomsActionType(evtName) {
  return createActionType(sliceKeys.relatedRooms, evtName);
}

function createDesksActionType(evtName) {
  return createActionType(sliceKeys.desks, evtName);
}

function createCreatePageActionType(evtName) {
  return createActionType(sliceKeys.createPage, evtName);
}

function createNewConfigPageActionType(evtName) {
  return createActionType(sliceKeys.newConfigPage, evtName);
}

function createChangeDesksSettingsPageActionType(evtName) {
  return createActionType(sliceKeys.changeDesksSettingsPage, evtName);
}

function createRoomListViewActionType(evtName) {
  return createActionType(sliceKeys.roomListView, evtName);
}

function createAttachmentsFilterActionType(evtName) {
  return createActionType(sliceKeys.attachmentsFilter, evtName);
}
